// Lib
import { createProvider } from 'react-redux';

// Constants
import { LIVE_COLLABORATION_STORE_NAME } from '../liveCollaborationConstants';

export default createProvider(LIVE_COLLABORATION_STORE_NAME);
